import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { AutoCompleteSliceReducer, authReducer, headerReducer } from "./Services/index";

const rootReducer = combineReducers({
    auth: authReducer,
    AutoComplete: AutoCompleteSliceReducer,
    header: headerReducer,
});

export const store = configureStore({ reducer: rootReducer });